<template>
  <div class="flex-center">
    <div :key="connector.id" v-for="connector in this.activeConnectors" @click="handlePickerLaunchEvent(connector.shortname)" class="uploadicn">
      <img class="connector-logo-small" :title="connector.description" :src="'/images/connector-logos/' + connector.shortname +'.png'">
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {EventBus} from "../../../event-bus";
import axios from "axios";


export default {
  name: "connector-tiles",
  props: [
      'OrderId'
  ],
  created() {
    gapi.load('picker');
  },
  data: function (){
    return {}
  },
  mounted () {
    this.loadActiveConnectors();
    this.loadFeatures();
  },
  computed: {
    formOrderId(){
      return this.OrderId ? this.OrderId : 0;
    },
    ...mapState('ConnectorTilesStore', [
        'activeConnectors'
    ]),
    ...mapState({
      uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
      features: state => state.store.features,
    }),
    ...mapGetters('FeatureFlagStore', {
      'getFeature': 'getFeatureStatusByName'
    }),
  },
  methods: {
    ...mapActions('FeatureFlagStore', [
      'loadFeatures'
    ]),
    ...mapActions('ConnectorTilesStore', [
      'loadActiveConnectors'
    ]),
    showDetails (data) {
      if(data.picked === 'picked') {
        console.log(data.docs)
      }
    },
    handlePickerLaunchEvent(connector){
      const orderId = this.formOrderId;
      let fileType = this.uploadFileType;

      switch (connector) {
        case 'hubspot':
          EventBus.$emit("show-hubspot-picker", {type: fileType, orderId}); break;
        case 'zendesk':
          EventBus.$emit("show-zendesk-picker", {type: fileType, orderId} ); break;
        case 'github':
          EventBus.$emit("show-github-picker", {type: fileType, orderId} ); break;
        case 'marketo':
          EventBus.$emit("show-marketo-picker", {type: fileType}); break;
        case 'google': this.launchDrivePicker(fileType, orderId); break;
        case 'onedrive': EventBus.$emit("show-onedrive-picker", {type: fileType, orderId} ); break;
        case 'dropbox': this.launchDropBoxPicker(fileType, orderId); break;
        case 'box': this.launchBoxPicker(fileType, orderId); break;
      }

    },
    launchDropBoxPicker (fileType, orderId) {
      console.log(this.formOrderId)
      var options = {
        success: (files) => {
          $.ajax({
            url: `/connectors/dropbox/upload?upload=dropbox&orderId=${orderId}&type=` + fileType,
            method: 'post',
            data: 'j=' + encodeURIComponent(JSON.stringify(files)),
            dataType: 'script',
            success: () => {
              //let any listeners know about the new file
              window.EventBus.$emit('file-uploaded');
            }
          });
        },
        linkType: 'direct',
        multiselect: true
      };
      Dropbox.choose(options);
    },
    launchOnedrivePicker (fileType, orderId) {
      var odOptions = {
        clientId: process.env.MIX_ONEDRIVE_APP_ID,
        action: "query",
        multiSelect: true,
        advanced: {},
        success: (files) => {
          $.ajax({
            url: `/connectors/onedrive/upload?&orderId=${orderId}&type=${fileType}`, // TODO
            data: {
              fileData: JSON.stringify(files),
              fileType: fileType
            },
            method: 'post',
            success: (data) => {
              //let any listeners know about the new file
              window.EventBus.$emit('file-uploaded');
            }
          });

        },
        cancel: function () { /* cancel handler */
        },
        error: function (error) { /* error handler */
        }
      };
      OneDrive.open(odOptions);

    },
    launchBoxPicker: (fileType, orderId) => {

      var boxoptions = {
        clientId: process.env.MIX_BOX_KEY,
        linkType: 'direct',
        multiselect: true
      };

      let boxSelect = new BoxSelect(boxoptions);

      boxSelect.success(function (response) {
        $.ajax(
            {
              url: `/connectors/box/upload?orderId=${orderId}&type=` + fileType,
              method: 'post',
              data: 'j=' + encodeURIComponent(JSON.stringify(response)),
              success: function () {
                window.EventBus.$emit('file-uploaded');
              }
            });
      });

      boxSelect.launchPopup();

    },
    launchDrivePicker: (fileType, orderId) => {
      // https://developers.google.com/drive/api/v3/picker
      axios.get('/connectors/google/refresh')
          .then((res) => {

            const token = res?.data?.token;

            if (!token) {

              popupAlert("<a href='/connectors'>Please reconnect with google, we need to refresh your account...</a>", 'Reconnect with google');
              return;

            }

            let userView = new google.picker.DocsView(google.picker.ViewId.DOCS);
            userView.setIncludeFolders(true);
            userView.setOwnedByMe(true);

            console.log(fileType);

            //https://developers.google.com/picker/docs/reference#ViewId
            let picker = new google.picker.PickerBuilder()
                .addView(userView)
                // .addView(sharedViewTab)
                .setOAuthToken(token)
                .enableFeature(google.picker.Feature.SUPPORT_DRIVES)
                .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
                .disableFeature(google.picker.Feature.NAV_HIDDEN)
                .setCallback((data) => {

                console.log(fileType);
                  if (data.action != google.picker.Action.PICKED) {

                    return false;

                  }

                  if (data.docs.length === 0) {
                    return;
                  }

                  $.ajax({
                    url: '/connectors/google/upload',
                    method: 'POST',
                    data: {
                      fileData: JSON.stringify(data),
                      fileType: fileType,
                      orderId: orderId
                    },
                    success: () => {
                      EventBus.$emit('file-uploaded');
                    }
                  });
                })
                .build();

            picker.setVisible(true);

      });
    }
  }
};
</script>

<style scoped>

</style>
